import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from './cn.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ className, children, ...rest }: CardProps) {
  return (
    <div
      data-surface="card"
      className={cn('rounded-lg bg-surface p-6 shadow-card', className)}
      {...rest}
    >
      {children}
    </div>
  );
}

export interface StatCardProps {
  label: string;
  value: string;
  icon?: ReactNode;
  className?: string;
}

export function StatCard({ label, value, icon, className }: StatCardProps) {
  return (
    <Card className={cn('flex items-center gap-4', className)}>
      {icon ? (
        <span className="flex size-11 shrink-0 items-center justify-center rounded-md bg-brand-soft text-brand">
          {icon}
        </span>
      ) : null}
      <span className="min-w-0">
        <span className="block truncate text-sm text-muted">{label}</span>
        <span className="block truncate text-xl font-semibold text-ink tabular-nums">{value}</span>
      </span>
    </Card>
  );
}
